import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, Injectable, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonicStorageModule } from '@ionic/storage-angular';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { CartActionsComponent } from '../app/components/cart/cart-actions/cart-actions.component';
import { environment } from '../environments/environment';
//import { DiamondSearchPageModule } from './pages/diamond-search/diamond-search.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderFooterComponentsModule } from './components/header-footer.components.module';
//import { IonIntlTelInputModule } from './components/ion-intl-tel-input/ion-intl-tel-input.module';
import { CompanyService } from './service/company/company.service';
import { ConfigServiceService } from './service/config-service.service';
import { HeaderFooterService } from './service/headerFooter/header-footer.service';
import { ThemeService } from './service/theme.service';
//import { DocumentViewer } from '@awesome-cordova-plugins/document-viewer/ngx';
// import { DocumentViewer } from '@ionic-native/document-viewer';
//import * as Hammer from 'hammerjs';

import {
  HammerModule,
  HammerGestureConfig,
  HAMMER_GESTURE_CONFIG,
} from '@angular/platform-browser';
import { CartAddedPopupPageModule } from './pages/cart-added-popup/cart-added-popup.module';
import { AnalyticsService } from './service/analytics.service';
import { ShowDNAComponent } from './components/DNA/show-dna.component';
import { BookAppointmentModule } from './components/book-appointment.module';
// import { SortCodesPipe } from './pipes/sort-code/sort-codes.pipe';
// @Injectable()
// export class MyHammerConfig extends HammerGestureConfig {
//   overrides = <any>{
//     swipe: { direction: Hammer.DIRECTION_ALL },
//   };
// }
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthInterceptor } from './auth.interceptor';

// Import Cloudinary Modules


import { DiamondSearchedParamsComponentModule } from './components/diamond-searched-params-component/diamond-searched-params-component.module';
import { IonicSelectableComponent } from 'ionic-selectable';

import { PipesModule } from 'src/app/pipes/pipes.module';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}





@NgModule({
  declarations: [AppComponent, CartActionsComponent, ShowDNAComponent],
  imports: [
    PipesModule,
    HeaderFooterComponentsModule,
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),

    HttpClientModule,
    // Ionic 7 escapes custom HTML in overlay messages (alert/toast/loading) by
    // default; re-enable it so HTML templates like the Share Link alert render.
    IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    FormsModule,
    CartAddedPopupPageModule,
    BookAppointmentModule,
    DiamondSearchedParamsComponentModule,
    BrowserAnimationsModule,
    IonicSelectableComponent,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    ConfigServiceService,
    AnalyticsService,
    CompanyService,
    HeaderFooterService,
    ThemeService,
    Meta,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
